/** @jsx jsx */
/* eslint-disable no-use-before-define,no-mixed-operators */
import { jsx } from '@emotion/core'
import React from 'react'
import { CORP_SECTOR_LABELS, YES_NO,
    Section, getState, fmt,
    showModal, parseHtml,
    matIcon,
    iconLabel,
} from '../twd'
import { useBondDetail } from './use-bond-detail'
import { sectionCss, sectionListCss, } from './style'
import { INV_TYPE_LABELS } from './bond-detail'
import Underwriter from './underwriter'

const state = getState('bond_detail.bond_features', {
    show: true
})

export default () => {
    const [showSection, setShowSection_] = React.useState(state.value.show)
    const setShowSection = React.useCallback((m) => {
        state.set({show:m})
        setShowSection_(m)
    }, [])


    const {issue, events} = useBondDetail()
    let invType = issue.spInd==='Y' ? 'L' : issue.type
    let hasEvents = ['C', 'M', 'A', 'L'].indexOf(invType) >= 0
        && !(issue.type==='S' && issue.spInd==='Y' && issue.category==='N')

    return <React.Fragment>
    <div className="xs-hide vertical-offset-sm"></div>
    <div data-name='bond-detail-bond-features'
        className="container vertical-offset-sm"
        css={sectionCss}>

        <div className="row vertical-offset-sm"></div>
        <div className="row"><div className="col-xs-12">
            <Section
                title={INV_TYPE_LABELS[invType] + " features"}
                show={showSection}
                setShow={setShowSection}
                cls="small-header"
                arrowSize="large"
            >
            <dl css={sectionListCss}>
            {
                invType === 'A' ? <AgencyFeatures issue={issue} />
                : invType === 'R' ? <PassThroughAssetBackedCMOFeatures issue={issue} />
                : invType === 'K' ? <PassThroughAssetBackedCMOFeatures issue={issue} />
                : invType === 'S' ? <CDFeatures issue={issue} />
                : invType === 'O' ? <PassThroughAssetBackedCMOFeatures issue={issue} />
                : invType === 'L' ? <StructuredProductFeatures issue={issue} />
                : invType === 'C' ? <CorporateFeatures issue={issue} />
                : invType === 'M' ? <MunicipalFeatures issue={issue} />
                : invType === 'P' ? <PreferredFeatures issue={issue} />
                : invType === 'T' ? <TreasuryFeatures issue={issue} />
                : null
            }
            </dl>

            { hasEvents && (() => {
                let tab = invType === 'A' ? 'redemptions'
                    : invType==='M' ? 'material-event-filings'
                    : 'default-events'

                let lbl = invType === 'M' ? 'View all Material Events'
                    : 'View all events'

                return <div className="row"><div className="col-xs-12">
                <button
                    className="link-button"
                    onClick={(e) => {
                        showModal({
                            view: 'events',
                            tab,
                            issue,
                            events,
                            from: 'bond-detail',
                            source: e.target,
                        })
                    }}>
                { iconLabel(matIcon('timeline'), lbl) }
                </button>
                </div></div>
            })() }

            </Section>
        </div></div>

        <div className="row vertical-offset-sm"></div>

    </div>

    </React.Fragment>
}

let CorporateFeatures = ({issue}) => <React.Fragment>
    <dt>Sector</dt>
    <dd>{CORP_SECTOR_LABELS[issue.sectorCode]}</dd>

    <dt>Convertible</dt>
    <dd>{issue.convertibleInd === 'Y' ? parseHtml(issue.convertibleText) : 'No'}</dd>

    <dt>Listed</dt>
    <dd>{YES_NO[issue.convertibleInd] || fmt.empty()}</dd>

    <dt>Symbol</dt>
    <dd>{issue.symbol || fmt.empty()}</dd>

    <dt>Debt Ranking</dt>
    <dd>{issue.drnkDesc || fmt.empty()}</dd>

    <dt>Religious org</dt>
    <dd>{(issue.religiOrg || '').trim() || fmt.empty()}</dd>
    </React.Fragment>


let MunicipalFeatures = ({issue}) => <React.Fragment>
    <dt>Category</dt>
    <dd>{parseHtml(issue.categoryDesc) || fmt.empty()}</dd>

    <dt>State</dt>
    <dd>{issue.state || fmt.empty()}</dd>

    <dt>Use of proceeds</dt>
    <dd>{parseHtml(issue.useofproceedsdesc) || fmt.empty()}</dd>

    <dt>Debt Ranking</dt>
    <dd>{issue.drnkDesc || fmt.empty()}</dd>

    <dt>Federally taxable</dt>
    <dd>{YES_NO[issue.taxable] || fmt.empty()}</dd>

    <dt>State taxable</dt>
    <dd>{YES_NO[issue.stateTaxExempt==='No' ? 'N' : 'Y'] || fmt.empty()}</dd>

    <dt>Subject to AMT</dt>
    <dd>{YES_NO[issue.altMinTax] || fmt.empty()}</dd>

    <dt>Bank qualified</dt>
    <dd>{YES_NO[issue.bankQualified] || fmt.empty()}</dd>

    <dt>Build America Bonds</dt>
    <dd>{YES_NO[issue.babInd] || fmt.empty()}</dd>

    <dt>Religious org</dt>
    <dd>{(issue.religiOrg || '').trim() || fmt.empty()}</dd>

    <dt>Obligor</dt>
    <dd>{parseHtml(issue.corporationName) || fmt.empty()}</dd>

    <dt>Project name</dt>
    <dd>{issue.projectName || fmt.empty()}</dd>

    <dt>Enhancement</dt>
    <dd>{issue.enhancement || fmt.empty()}</dd>

    <dt>Primary insurance</dt>
    <dd>{issue.insurance || fmt.empty()}
    {(() =>{
        let a = issue.insurance && issue.primInsurerRatingList && issue.primInsurerRatingList[0]
        return a ? [' (', a.moodyRating, '/', a.spRating, ')'].join('') : ''
    })()}</dd>

    <dt>Secondary insurance</dt>
    <dd>{issue.secInsurance || fmt.empty()}
    {(() =>{
        let a = issue.secInsurance && issue.secInsurerRatingList && issue.secInsurerRatingList[0]
        return a ? [' (', a.moodyRating, '/', a.spRating, ')'].join('') : ''
    })()}</dd>

    <dt>Reinsurance</dt>
    <dd>{issue.reinsurance || fmt.empty()}
    {(() =>{
        let a = issue.reinsurance && issue.reinsInsurerRatingList && issue.reinsInsurerRatingList[0]
        return a ? [' (', a.moodyRating, '/', a.spRating, ')'].join('') : ''
    })()}</dd>

    <dt>Redemption type</dt>
    <dd>{issue.redemptionTypeDesc || fmt.empty()}</dd>

    <dt>Escrowed</dt>
    <dd>{YES_NO[issue.escrowedToMaturity] || fmt.empty()}</dd>

    <dt>PreRefunded</dt>
    <dd>{YES_NO[issue.preRefund] || fmt.empty()}</dd>

    <dt>Min amount</dt>
    <dd>{fmt.qty(issue.minAmt)}</dd>

    <dt>Increment amount</dt>
    <dd>{fmt.qty(issue.denominationAmt)}</dd>

    <dt>Deminimus price</dt>
    <dd>{fmt.priceDemin(issue.marketDiscPoint)}</dd>

    <dt>Environmental type</dt>
    <dd>{parseHtml(issue.environmental) || fmt.empty()}</dd>

    </React.Fragment>

let CDFeatures = ({issue}) => <React.Fragment>
    <dt>New Issue</dt>
    <dd>{YES_NO[issue.newIssueInd] || fmt.empty()}</dd>

    <dt>Blue Sky Sate Restrictions</dt>
    <dd dangerouslySetInnerHTML={{__html:parseHtml((issue.bluesky || '').replaceAll('<BR>','').split(',').join(',\u200b') || fmt.emptyHtml)}} />

    <dt>City, state</dt>
    <dd>{
        ((issue.city ? issue.city + ', ' : '') + (issue.state || '')) || fmt.empty()
    }</dd>

    <dt>FDIC number</dt>
    <dd>{issue.fdic || fmt.empty()}</dd>
    </React.Fragment>

let AgencyFeatures = ({issue}) => <React.Fragment>
    <dt>Issuer</dt>
    <dd>{issue.issuer || fmt.empty()}</dd>
</React.Fragment>

let TreasuryFeatures = ({issue}) => <React.Fragment>
    <dt>Type</dt>
    <dd>{issue.categoryDesc || fmt.empty()}</dd>
    </React.Fragment>

let StructuredProductFeatures = ({issue}) => <React.Fragment>
    <dt>Category</dt>
    <dd>{issue.categoryDesc || fmt.empty()}</dd>

    <dt>Class</dt>
    <dd>{issue.subCatClass || fmt.empty()}</dd>

    <dt>Program type</dt>
    <dd>{issue.programType || fmt.empty()}</dd>

    <dt>Payoff profile</dt>
    <dd>{issue.payoffDesc || fmt.empty()}</dd>

    <dt>Issuer</dt>
    <dd>{issue.issuer || fmt.empty()}</dd>

    <dt>Underwriter</dt>
    <dd><Underwriter html={issue.underwriter} /></dd>

    <dt>City, state</dt>
    <dd>{
        ((issue.city ? issue.city + ', ' : '') + (issue.state || '')) || fmt.empty()
    }</dd>

    <dt>FDIC number</dt>
    <dd>{issue.fdic || fmt.empty()}</dd>

    </React.Fragment>

let PassThroughAssetBackedCMOFeatures = ({issue}) => <React.Fragment>
    <dt>Category</dt>
    <dd>{issue.categoryDesc || fmt.empty()}</dd>

    <dt>WAM</dt>
    <dd>{parseHtml(issue.wghtdAvgMaturity) || fmt.empty()}</dd>

    <dt>WAM date</dt>
    <dd>{fmt.mdy(issue.wghtdAvgMaturityDt)}</dd>

    <dt>WAC</dt>
    <dd>{parseHtml(issue.wghtdAvgCoupon) || fmt.empty()}</dd>

    <dt>WAC date</dt>
    <dd>{fmt.mdy(issue.wghtdAvgCouponDt)}</dd>

    <dt>WALA</dt>
    <dd>{issue.wghtdAvgLoanAge || fmt.empty()}</dd>

    <dt>Pool type</dt>
    <dd>{issue.poolType || fmt.empty()}</dd>

    <dt>Pool number</dt>
    <dd>{issue.poolNo || fmt.empty()}</dd>

    <dt>Tranche type</dt>
    <dd>{parseHtml(issue.trancheDesc) || fmt.empty()}</dd>

    <dt>Collateral</dt>
    <dd>{parseHtml(issue.collateralDesc) || fmt.empty()}</dd>

    <dt>Collateral coupon</dt>
    <dd>{fmt.cpn(issue.collateralCoupon)}</dd>

    <dt>Payment delay</dt>
    <dd>{issue.daysDelay || fmt.empty()}</dd>

    <dt>Factor</dt>
    <dd>{
        issue.factor && <button
            className="link-button"
            onClick={(e) => {
                showModal({
                    view: 'factors',
                    list: issue.factorList,
                    from: 'bond-detail',
                    source: e.target,
                })
            }}>
        {issue.factor}
        </button>
        || fmt.empty()
    }</dd>

    <dt>FFIEC</dt>
    <dd>{issue.ffiecFlag || fmt.empty()}</dd>
    </React.Fragment>

let PreferredFeatures = ({issue}) => <React.Fragment>
    <dt>Issuer</dt>
    <dd>{parseHtml(issue.issuer) || fmt.empty()}</dd>

    <dt>Symbol</dt>
    <dd>{issue.symbol || fmt.empty()}</dd>

    <dt>Exchange</dt>
    <dd>{issue.exchangeDesc || fmt.empty()}</dd>

    <dt>Category</dt>
    <dd>{issue.categoryDesc || fmt.empty()}</dd>

    <dt>Debt Ranking</dt>
    <dd>{issue.drnkDesc || fmt.empty()}</dd>

    <dt>QDI eligibility</dt>
    <dd>{issue.qdi || fmt.empty()}</dd>

    <dt>Ex-Div date</dt>
    <dd>{fmt.mdy(issue.exDividendDt)}</dd>

    <dt>Div pay date</dt>
    <dd>{fmt.mdy(issue.dividendPayDt)}</dd>

    <dt>Lead manager</dt>
    <dd>{issue.leadManager || fmt.empty()}</dd>

    <dt>Security notes</dt>
    <dd>{fmt.initCap(issue.note) || fmt.empty()}</dd>
    </React.Fragment>